import React from 'react';

import useSiteSettings from '#hooks/useSiteSettings';
import { getGtmNoScriptSrc, getSafeGtmContainerId } from '#helper/google-tag-manager';

const GoogleTagManagerNoScript = () => {
   const { gtmContainerId } = useSiteSettings();
   const safeGtmContainerId = getSafeGtmContainerId(gtmContainerId);

   if (!safeGtmContainerId) return null;

   return (
      <noscript>
         <iframe
            src={getGtmNoScriptSrc(safeGtmContainerId)}
            height="0"
            width="0"
            title="Google Tag Manager"
            style={{ display: 'none', visibility: 'hidden' }}
         />
      </noscript>
   );
};

const wrapPageElementWithGtmNoScript = ({ element }) => (
   <>
      <GoogleTagManagerNoScript />
      {element}
   </>
);

export { GoogleTagManagerNoScript, wrapPageElementWithGtmNoScript };
